/**
 * OrderMixin
 */
import { mapState, mapGetters, mapActions } from 'vuex';

import { SettingMixin } from '@/mixins/Setting';

import FirstBuy from '@/components/FirstBuy.vue';

import { getIsWechatBrowser, getIsMobile } from '@/utils/browser';

import { OrderMixin } from './Order.mixin';

export const OrderWriteOffMixin = {
  name: 'OrderWriteOffMixin',

  mixins: [SettingMixin, OrderMixin],

  components: {
    FirstBuy,
  },

  data: () => {
    return {
      promiseGetMallGoodQrcode: null,

      giftsList: [],

      addForFreeStatus: 0,

      promiseGetStudentAndTutorInfo: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('Mall/Order', {
      ms_order: 'order',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_goodId() {
      return this.$route.params.goodId;
    },

    c_isCoupon() {
      return 4 === this.ms_order.category || 5 === this.ms_order.category;
    },

    c_isCategorySourcePG() {
      return 'PG' === this.ms_order.categorySource;
    },

    c_isCourse() {
      return !this.c_isCoupon && !this.c_isCategorySourcePG;
    },

    c_isHasQHGoods() {
      return this.ms_order.hasQHGoods;
    },

    c_isCpaCourse() {
      return 3 === this.ms_order.category;
    },

    c_isQianRenCourse() {
      return 7 === this.ms_order.category;
    },

    c_isSaCourse() {
      return 10 === this.ms_order.category;
    },

    c_isSpecialCourse() {
      return 5990 == this.ms_order.goodsId;
    },

    c_cpaGoodsDetailName() {
      if (this.c_isCpaCourse) {
        return this.makeCpaGoodsDetailName(this.ms_order.goodsDetailName);
      } else {
        return '';
      }
    },

    c_isStep1Needed() {
      return false;
      //if (
      //  this.ms_order &&
      //  !this.ms_order.wechatValidated &&
      //  (!this.ms_order.wechatSell || this.ms_order.maxCapacity > 0) &&
      //  this.c_isCourse &&
      //  (!this.c_hasWechatNo || !this.c_hasMobile || !this.c_hasEmail)
      //) {
      //  return true;
      //} else {
      //  return false;
      //}
    },

    c_isSalesQrCodeNeeded() {
      return this.ms_order && this.ms_order.salesQrCode ? true : false;
    },

    c_isEsg_7672() {
      return false;
    },

    c_isWechatBrowser() {
      return getIsWechatBrowser();
    },

    c_isMobile() {
      return getIsMobile();
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
      ma_getTutorInfo: 'getTutorInfo',
    }),

    getMallGoodQrcode() {
      //
    },

    addForFree() {
      //
    },

    getStudentAndTutorInfo() {
      this.promiseGetStudentAndTutorInfo = Promise.all([
        this.ma_getUserInfo(),
        this.ma_getTutorInfo(),
      ]);
    },

    addForFreeStatusNextStep() {
      if (this.addForFreeStatus < 9 && this.c_isSalesQrCodeNeeded) {
        this.addForFreeStatus = 9;
        return;
      }
      if (this.addForFreeStatus < 10 && this.c_isStep1Needed) {
        this.addForFreeStatus = 10;
        return;
      }
      if (this.c_isEsg_7672) {
        this.$router.push('/esg-order-completed');
      } else {
        this.addForFreeStatus = 1;
      }
    },

    async setGiftsList() {
      await this.promiseGetMallGoodQrcode;
      this.giftsList = this.ms_order.giftsList;
    },
  },
};

export default OrderWriteOffMixin;
